import { Table } from '@statsbomb/kitbag-components';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  REACT_APP_AUTH_ROLE_COLLECTOR,
  REACT_APP_AUTH_ROLE_OPERATOR,
} from '../../AuthProvider';
import { videoReferencePropTypes } from '../../types/videoReference';
import BooleanDisplay from '../BooleanDisplay';
import Secured from '../Secured';
import { ToggleDoNotUse } from '../ToggleDoNotUse/ToggleDoNotUse';

export function VideoAdditionalSettings({
  isDoNotUse,
  videoReference,
  lastUpdatedBy,
  lastUpdatedByIsHidden,
}) {
  return (
    <Table>
      <Table.Head>
        <Table.HeaderCell colSpan={2}>
          <FormattedMessage defaultMessage="Additional Settings" id="0ae95" />
        </Table.HeaderCell>
      </Table.Head>
      <Table.Body>
        {!lastUpdatedByIsHidden && (
          <Table.Row>
            <Table.DataCell $textAlign="left">
              <FormattedMessage defaultMessage="Last Updated By" id="7ce1b" />
            </Table.DataCell>
            <Table.DataCell $textAlign="left">
              {lastUpdatedBy || '-'}
            </Table.DataCell>
          </Table.Row>
        )}
        <Table.Row>
          <Table.DataCell $textAlign="left">
            <FormattedMessage defaultMessage="Do Not Use" id="e966c" />
          </Table.DataCell>
          <Table.DataCell $textAlign="left">
            <Secured allowed={REACT_APP_AUTH_ROLE_OPERATOR}>
              <ToggleDoNotUse
                isDoNotUse={isDoNotUse}
                videoReference={videoReference}
              />
            </Secured>
            <Secured allowed={REACT_APP_AUTH_ROLE_COLLECTOR}>
              <BooleanDisplay value={isDoNotUse} />
            </Secured>
          </Table.DataCell>
        </Table.Row>
      </Table.Body>
    </Table>
  );
}

VideoAdditionalSettings.propTypes = {
  isDoNotUse: PropTypes.bool.isRequired,
  lastUpdatedBy: PropTypes.string,
  lastUpdatedByIsHidden: PropTypes.bool,
  videoReference: PropTypes.shape(videoReferencePropTypes).isRequired,
};

VideoAdditionalSettings.defaultProps = {
  lastUpdatedBy: '-',
  lastUpdatedByIsHidden: false,
};

export default VideoAdditionalSettings;
